export const Types = {
    SET_ALERT: 'SET_ALERT',

    DEAL_NAME: 'DEAL_NAME',
    DEAL_DESC: 'DEAL_DESC',
    DEAL_WEBSITE_URL: 'DEAL_WEBSITE_URL',
    DEAL_LEAD_INVESTOR: 'DEAL_LEAD_INVESTOR',
    DEAL_CRYPTO: 'DEAL_CRYPTO',
    DEAL_STATUS: 'DEAL_STATUS',
    DEAL_PRICE: 'DEAL_PRICE',
    DEAL_PRESAIL_AMOUNT: 'DEAL_PRESAIL_AMOUNT',
    DEAL_MINSALE_AMOUNT: 'DEAL_MINSALE_AMOUNT',
    DEAL_MAXSALE_AMOUNT: 'DEAL_MAXSALE_AMOUNT',
    DEAL_START_BONUS: 'DEAL_START_BONUS',
    DEAL_END_BONUS: 'DEAL_END_BONUS',
    DEAL_LOGO: 'DEAL_LOGO',
    DEAL_OFFER_PERIOD: 'DEAL_OFFER_PERIOD',
    DEAL_OFFER_TERMS: 'DEAL_OFFER_TERMS',
    DEAL_MIN_STAKE_AMOUNT: 'DEAL_MIN_STAKE_AMOUNT',
    DEAL_MAX_STAKE_AMOUNT: 'DEAL_MAX_STAKE_AMOUNT',

    STAKE_AMOUNT: 'STAKE_AMOUNT'
}